<template>
    <div class="white-label-preview-container">
        <div class="header-preview-container">
            <!-- HEADER PREVIEW -->
            <div
                class="preview-header"
                :style="{ backgroundColor: primaryColor }"
            >
                <div class="logo-wrapper">
                    <img :src="logoUrl" alt="Logo" />
                </div>
                <div class="user-info">
                    <span class="material-icons user-icon">account_circle</span>
                    <span class="user-name">Usuário</span>
                </div>
            </div>

            <!-- EXEMPLO DE BOTÕES -->
            <div class="preview-body">
                <button
                    class="custom-button active"
                    :style="{ backgroundColor: primaryColor + '27' }"
                >
                    <span
                        class="button-icon material-icons"
                        :style="{ color: primaryColor }"
                        >inventory_2</span
                    >
                    Ranking Produtos
                </button>

                <button
                    class="buttonV3 btn-filter"
                    :style="{ backgroundColor: primaryColor, color: '#fff' }"
                >
                    <span class="material-icons" style="color: #fff"
                        >search</span
                    >
                    Filtrar
                </button>

                <button
                    class="buttonV3 btn-clear"
                    style="background-color: #fff; color: #333; font-weight: 600;"
                >
                    <span
                        class="material-icons"
                        :style="{ color: primaryColor, fontWeight: 600 }"
                        >delete</span
                    >
                    Limpar filtros
                </button>
            </div>
        </div>
        <!-- TELA DE LOGIN -->
        <div
            class="login-preview"
            :style="{
                backgroundImage: `url('${backgroundUrl}')`
            }"
        >
            <div class="login-box-whitelabel">
                <img
                    class="login-logo-whitelabel"
                    :src="logoUrlLogin"
                    alt="Logo"
                />

                <div class="input-group">
                    <span
                        class="material-icons"
                        :style="{ color: primaryColor }"
                        >person</span
                    >
                    <input type="text" placeholder="Usuário" />
                </div>

                <div class="input-group">
                    <span
                        class="material-icons"
                        :style="{ color: primaryColor }"
                        >lock</span
                    >
                    <input type="password" placeholder="Senha" />
                </div>

                <div class="login-row">
                    <span>Esqueceu a senha?</span>
                </div>

                <button
                    class="login-button"
                    :style="{ backgroundColor: primaryColor }"
                >
                    LOGIN
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "WhiteLabelPreview",
    props: {
        primaryColor: {
            type: String,
            default: "#ff6f2c"
        },
        logoUrl: {
            type: String,
            default: ""
        },
        logoUrlLogin: {
            type: String,
            default: ""
        },
        backgroundUrl: {
            type: String,
            default: ""
        }
    }
};
</script>

<style scoped>
.white-label-preview-container {
    width: 100%;
    max-width: 1000px;
}

.header-preview-container {
    border: 1px solid #ccc;
    border-radius: 4px;
    overflow: hidden;
    /* margin-top: 3rem; */
}

/* HEADER */
.preview-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem 1rem;
    color: white;
}
.logo-wrapper img {
    max-height: 40px;
    object-fit: contain;
    border-radius: 8px;
}
.user-info {
    display: flex;
    align-items: center;
    font-weight: bold;
}
.user-icon {
    font-size: 1.8rem;
}

/* BOTÕES */
.preview-body {
    padding: 1rem;
    display: flex;
    justify-content: space-around;
    gap: 1rem;
    background-color: #fafafa;

    flex-wrap: wrap;
}
.custom-button {
    border: none;
    white-space: nowrap;
    color: #202020 !important;
    cursor: pointer;
    font-weight: 600;
    font-size: 18px;
    padding: 15px 12px;
    border-radius: 8px;
    background-color: transparent;
    display: flex;
    align-items: center;
    transition: background-color 0.3s, color 0.3s;
}
.custom-button .material-icons {
    font-size: 20px;
    margin-right: 8px !important;
}
.buttonV3 {
    border: none;
    display: flex;
    align-items: center;
    padding: 13px 15px;
    border-radius: 5px;
    border: 1px solid #e5e5e5;
    font-weight: 600;
    font-size: 16px;
    gap: 8px;
    cursor: pointer;
}

/* LOGIN */
.login-preview {
    margin-top: 1rem;
    background-size: cover;
    background-position: center;
    padding: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
}

.login-box-whitelabel {
    background-color: #ffffff;
    border-radius: 10px;
    padding: 2rem;
    width: 100%;
    max-width: 350px;
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.login-logo-whitelabel {
    max-height: 60px;
    object-fit: contain;
    /* margin-bottom: 0.5rem; */
    align-self: center;
    border-radius: 8px;
}
.input-group {
    display: flex;
    align-items: center;
    border: 2px solid #ccc;
    padding: 5px;
    border-radius: 10px;
    background: #fff;
}
.input-group input {
    border: none;
    outline: none;
    flex: 1;
}
.login-button {
    border: none;
    color: #fff;
    font-weight: bold;
    padding: 7px;
    border-radius: 10px;
    cursor: pointer;
    font-size: 16px;
}

.login-row {
    text-align: right;
    font-size: 0.9rem;
    font-size: 15px;
    color: #828282;
}

.login-options {
    text-align: center;
    font-size: 0.85rem;
    margin-top: 1.5rem;
}

.social-icons {
    display: flex;
    justify-content: center;
    gap: 12px;
    margin: 10px 0;
}

.social-icons i {
    font-size: 1.5rem;
}
</style>
